module.exports = __webpack_public_path__ + "img/volumetrie_plus_125.78d7400c.png";